class FaqAccordion extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener("faq-item-clicked", this.handleItemClick);
  }

  disconnectedCallback() {
    this.removeEventListener("faq-item-clicked", this.handleItemClick);
  }

  handleItemClick(event) {
    const clickedItem = event.detail.item;

    // Close other items
    this.querySelectorAll("faq-item[opened]").forEach((item) => {
      if (item !== clickedItem) {
        item.removeAttribute("opened");
        item.querySelector(".faq-answer").style.maxHeight = "0";
      }
    });
  }
}

class FaqItem extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const question = this.querySelector(".faq-question");
    const answer = this.querySelector(".faq-answer");

    if (this.hasAttribute("opened")) {
      answer.style.maxHeight = answer.scrollHeight + "px";
    }

    question.addEventListener("click", () => this.toggle());
  }

  toggle() {
    const isOpen = this.hasAttribute("opened");
    const answer = this.querySelector(".faq-answer");

    if (isOpen) {
      this.removeAttribute("opened");
      answer.style.maxHeight = "0";
    } else {
      this.setAttribute("opened", "");
      answer.style.maxHeight = answer.scrollHeight + "px";

      // Notify parent accordion
      this.dispatchEvent(
        new CustomEvent("faq-item-clicked", {
          bubbles: true,
          detail: { item: this },
        })
      );
    }
  }
}

if (!customElements.get("faq-accordion")) {
  customElements.define("faq-accordion", FaqAccordion);
}

if (!customElements.get("faq-item")) {
  customElements.define("faq-item", FaqItem);
}
